import React from "react";
import { Flex, Text, Box, Badge } from "@radix-ui/themes";
import { AccessLabelsEditor } from "@/features/knowledge-articles/AccessLabelsEditor";
import { useFlag } from "@/v2/components/feature-flag/FeatureFlagContext";
import { CommentBody } from "@/features/ticket-transcript/CommentBody";
import { ArticleRow } from "./articles-table.types";
import styles from "./styles.module.scss";

interface ArticleDetailProps {
  article: ArticleRow | null;
  onClose: () => void;
  onRefreshArticles?: () => void | Promise<void>;
}

export const ArticleDetail = ({ article, onClose, onRefreshArticles }: ArticleDetailProps) => {
  const accessLabelsEnabled = useFlag("articleAccessLabels");

  if (!article) {
    return (
      <Flex
        direction="column"
        align="center"
        justify="center"
        p="8"
        gap="2"
        height="100%"
      >
        <Text size="3" color="gray" weight="medium">
          No article selected
        </Text>
      </Flex>
    );
  }

  return (
    <div className={styles.articleDetailContainer}>
      <div className={styles.articleDetailMain}>
        <div className={styles.articleDetailContent}>
          <Flex gap={"1"} flexGrow="1" direction={"column"}>
            <Text as="div" dir="auto" size={"8"} weight={"bold"} style={{ fontWeight: 500 }}>
              {article.title}
            </Text>
            <Flex gap="2" align="center">
              {article.updatedAt && (
                <Text
                  size="2"
                  as="div"
                  color="gray"
                >
                  Updated at: {article.updatedAt}
                </Text>
              )}
              <Badge size="1" color={article.external ? "blue" : "red"}>
                {article.external ? "External" : "Internal"}
              </Badge>
            </Flex>
            {accessLabelsEnabled && (
              <AccessLabelsEditor
                articleId={article.articleId}
                initialLabels={article.accessLabels}
                onSave={onRefreshArticles}
                saveButtonPosition="right"
              />
            )}
          </Flex>
          <div className={styles.articleDetailScrollArea}>
            {article.content ? (
              <Box
                p="4"
                dir="auto"
                className={styles.articleDetailContentBox}
              >
                <CommentBody body={article.content} color="gray" />
              </Box>
            ) : (
              <Text as="div" size="3" style={{ whiteSpace: "pre-line" }}>
                No content available yet.
              </Text>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

